module.exports = __webpack_public_path__ + "img/message.39c7bca2.svg";